<template>

  <el-dialog
      :title="type == 'wxpay' ? '微信支付' : '支付宝支付'"
      append-to-body
      :visible.sync="visible"
      width="500px"
      :before-close="handleClose">
    <div class="qrcode-area ta-c" v-loading="loading">
      <div class="code-content">
        <div class="code-price">{{ list.price ? list.price + '元' : '' }}</div>
        <div class="code-tip">请使用<strong style="color: #0d90ff">{{
            type == 'wxpay' ? '微信支付' : '支付宝支付'
          }}</strong>扫码支付，剩余时间 00:{{ showMin }}:{{ showSec }}
        </div>
        <div class="code-img">
          <img v-if="list.codeImg" class="image-code" :src="list.codeImg" alt/>
        </div>
      </div>
      <!-- <img class="image-pay-way mt10" src="@/assets/login/image-pay-way.png" alt /> -->
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取消支付</el-button>
  </span>


  </el-dialog>

</template>

<script>

import Cookie from "js-cookie";

export default {
  name: "payDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    payList: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'wxpay'
    }
  },
  data() {
    return {
      loading: false,
      list: {},
      minutes: 15,
      seconds: 0,
      showMin: 15,
      showSec: 0,
      countTimer: null,
      orderTimer: null,
      dialogVisible: true
    };
  },
  created() {
    this.createApplyAuthOrder()
  },
  watch: {
    seconds: {
      handler(newVal) {
        this.showSec = this.num(newVal);
      }
    },
    minutes: {
      handler(newVal) {
        this.showMin = this.num(newVal);
      }
    }
  },
  methods: {
    num(n) {
      return n < 10 ? "0" + n : "" + n;
    },
    timer() {
      let _this = this;
      this.countTimer = setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59;
          _this.minutes -= 1;
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0;
          if (this.countTimer) {
            clearInterval(this.countTimer);
          }

          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = 0
          }

          _this.minutes = 15;
          _this.seconds = 0;
          //如果到15分钟了，就重新创建一个订单，然后继续倒计时
          _this.$message.error('支付超时')
          _this.createApplyAuthOrder()
        } else {
          _this.seconds -= 1;
        }
      }, 1000);
    },
    createApplyAuthOrder() {
      if (this.countTimer) {
        clearInterval(this.countTimer);
      }
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.annualSurvey, this.payList).then(res => {
        if (res.data.code == 200) {
          this.list = {
            ...res.data.data,
            codeImg: "data:image/png;base64," + res.data.data.buyQrcode,
          }
          if (res.data.data.payStatus == '0') {
            this.list = {
              ...res.data.data,
              codeImg: "data:image/png;base64," + res.data.data.buyQrcode,
            }
            this.timer();
            this.orderTimer = setTimeout(() => {
              this.doTrackTrade();
            }, 3000);
            this.loading = false
          } else {
            this.doTrackTrade();
          }
        } else {
          this.$message.error(res.data.msg)
          this.updateDialog(false)
          this.loading = false
        }
      })
    },
    doTrackTrade() {
      if (!this.list.tradeNo) return

      if (this.orderTimer) {
        clearTimeout(this.orderTimer)
        this.orderTimer = null
      }

      let params = {
        tradeNo: this.list.tradeNo
      };

      this.$http.post(this.$api.register.doTrackTrade, params, {
        "Content-Type": "multipart/form-data"
      }).then(res => {
        if (!this.dialogVisible) return
        if (res.data.code == 200) {
          if (res.data.data === true) {
            this.$message.success('支付成功')
            this.updateDialog(false)
            this.$emit('closeAll');
          } else {
            //定时器
            this.orderTimer = setTimeout(() => {
              this.doTrackTrade();
            }, 3000);
          }
        } else {
          this.updateDialog(false);
          this.$message.error(res.data.msg || '支付失败')
        }
      });
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(() => {
            this.updateDialog(false)
          })
          .catch(() => {
          });
    },
    /* 更新visible */
    updateDialog(value) {
      if (this.orderTimer) {
        clearTimeout(this.orderTimer);
        this.orderTimer = null
      }

      if (this.countTimer) {
        clearInterval(this.countTimer);
        this.countTimer = null
      }
      this.dialogVisible = false
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
.code-content {
  width: 309px;
  height: 332px;
  padding-top: 15px;
  margin: 20px auto 0;
  background: url("~@/assets/login/image-code.png") 100% 100% no-repeat;
  box-sizing: border-box;

  .code-price {
    margin-bottom: 5px;
    font-size: 24px;
    font-weight: 400;
    color: #ed3946;
  }

  .code-tip {
    font-size: 13px;
    color: #999;
    margin-bottom: 10px;
  }

  .code-img {
    height: 200px;
    // width: 166px;
    margin: 40px 25px 0;

    .image-code {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
